import React from 'react';
import { BriefcaseIcon, CalendarDaysIcon, MegaphoneIcon, PawPrintIcon } from 'lucide-react';
import { pillars } from '../data/landing';
import type { Pillar } from '../data/landing';
const icons: Record<Pillar['icon'], React.ComponentType<{
  className?: string;
  strokeWidth?: number;
}>> = {
  learn: PawPrintIcon,
  service: BriefcaseIcon,
  clients: MegaphoneIcon,
  organize: CalendarDaysIcon
};
export function WhatYouFind() {
  return <section id="que-encontras" className="bg-cream py-14 sm:py-20" data-id="element-123" data-mp="33tant27uny0u">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-124" data-mp="2zs8ji6z2svs0">
        <h2 className="text-center font-display text-3xl font-semibold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-125" data-mp="2zvmkbas3cwxc">
          Todo lo que necesitás para empezar.
        </h2>

        <ul className="mt-10 grid gap-x-10 gap-y-6 sm:grid-cols-2" data-id="element-126" data-mp="38rvkwsrt21l2">
          {pillars.map(pillar => {
          const Icon = icons[pillar.icon];
          return <li key={pillar.title} className="flex items-start gap-3.5" data-id="element-127" data-mp="1ehi7ejrjquom">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-white text-petrol shadow-card" data-id="element-128" data-mp="3jaiofhrs0j6a">
                  <Icon className="h-[18px] w-[18px]" strokeWidth={2.1} data-id="element-129" data-mp="3o9c0r6vbu44v" />
                </span>
                <div data-id="element-130" data-mp="3s9m92q6ld6mw">
                  <h3 className="font-display text-lg font-semibold leading-snug tracking-tight text-petrol" data-id="element-131" data-mp="3s8b2kilrhks3">
                    {pillar.title}
                  </h3>
                  <p className="mt-1 font-sans text-[15px] leading-snug text-petrol/70" data-id="element-132" data-mp="5u1fqdxhcktf">
                    {pillar.description}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}